import { render } from "./OrderedItem.vue?vue&type=template&id=7f6ef2e6&scoped=true"
import script from "./OrderedItem.vue?vue&type=script&lang=js"
export * from "./OrderedItem.vue?vue&type=script&lang=js"

import "./OrderedItem.vue?vue&type=style&index=0&id=7f6ef2e6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f6ef2e6"]])

export default __exports__